// Piccolo aiuto per i componenti che l'originale disegnava con React a partire dai dati delle API
// (istruttoria_ai_controller, richieste_opportunita_controller).
// - h(): crea gli elementi; il testo entra solo come nodo di testo (mai innerHTML), così i testi dell'AI e i nomi dei
//   documenti restano testo.
// - link(): un <a> solo per un indirizzo http(s); altrimenti il contenuto in uno <span> con le stesse classi e senza
//   href, target o rel.
// - Disegno: tiene gli elementi tra un disegno e l'altro (chiave + firma dei dati), come React riusava il DOM: un campo
//   in scrittura non perde il fuoco, una sezione <details> aperta resta aperta quando i dati si rileggono.

const PROPRIETA = new Set(["value", "checked", "disabled", "open"])

export function h(tag, attrs = {}, ...figli) {
  const el = document.createElement(tag)
  for (const [k, v] of Object.entries(attrs || {})) {
    if (v == null || v === false) continue
    if (k === "on") Object.entries(v).forEach(([evento, fn]) => el.addEventListener(evento, fn))
    else if (PROPRIETA.has(k)) el[k] = v
    else el.setAttribute(k, v === true ? "" : String(v))
  }
  aggiungi(el, figli)
  return el
}

function aggiungi(el, figli) {
  for (const f of figli.flat(Infinity)) {
    if (f == null || typeof f === "boolean" || f === "") continue
    el.append(f instanceof Node ? f : String(f))
  }
}

export const httpSicuro = (url) => typeof url === "string" && /^https?:\/\//i.test(url.trim())

export function link(url, attrs, ...figli) {
  const { href: _h, target: _t, rel: _r, ...resto } = attrs || {}
  if (httpSicuro(url)) return h("a", { ...resto, href: url.trim(), target: _t, rel: _r }, ...figli)
  return h("span", resto, ...figli)
}

// Il testo di un valore come lo scrive React: niente per null, undefined e booleani
export const testo = (x) => (x == null || typeof x === "boolean" ? "" : String(x))

// I figli di `padre` diventano `nodi` (in quest'ordine) spostando il meno possibile: chi resta non viene staccato.
export function sincronizza(padre, nodi) {
  const voluti = new Set(nodi.filter(Boolean))
  ;[...padre.childNodes].forEach((n) => { if (!voluti.has(n)) n.remove() })
  let cursore = padre.firstChild
  for (const n of nodi) {
    if (!n) continue
    if (n === cursore) { cursore = cursore.nextSibling; continue }
    padre.insertBefore(n, cursore)
  }
}

export class Disegno {
  constructor() {
    this.nodi = new Map()
    this.usati = new Set()
  }

  // L'elemento della chiave: lo stesso finché la firma non cambia, altrimenti uno nuovo che eredita le aperture
  nodo(chiave, firma, crea) {
    this.usati.add(chiave)
    const c = this.nodi.get(chiave)
    if (c && c.firma === firma) return c.el
    const el = crea()
    if (c) conservaAperture(c.el, el)
    this.nodi.set(chiave, { firma, el })
    return el
  }

  // dopo ogni disegno: dimentica gli elementi non più usati
  fine() {
    for (const k of [...this.nodi.keys()]) if (!this.usati.has(k)) this.nodi.delete(k)
    this.usati.clear()
  }

  azzera() {
    this.nodi.clear()
    this.usati.clear()
  }
}

function dettagli(el) {
  const tutti = [...el.querySelectorAll("details")]
  return el.tagName === "DETAILS" ? [el, ...tutti] : tutti
}

function conservaAperture(vecchio, nuovo) {
  const aperti = new Map(dettagli(vecchio).map((d, i) => [d.dataset.chiave ?? `#${i}`, d.open]))
  dettagli(nuovo).forEach((d, i) => {
    const k = d.dataset.chiave ?? `#${i}`
    if (aperti.has(k)) d.open = aperti.get(k)
  })
}
